import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConversionType, EfficiencyTransport } from '../../../../../models';
import { AbstractSpaceClass } from '../../../../../models/space/abstract-space.class';
import { NonRentableSpaceClass } from '../../../../../models/space/non-rentable-space.class';
import { TenantSpaceClass } from '../../../../../models/space/tenant-space.class';
import { NotificationService } from '../../../../../shared/services/notification.service';
import { StackingPlanService } from '../../../../../stacking-plan.service';
import { ActionsToolbarService } from '../../../../actions-toolbar/actions-toolbar.service';
import { NonRentableSpaceComponent } from '../../../../dialogs/non-rentable-space/non-rentable-space.component';
import { deleteNonRentableSpaceInfo } from '../../../../dialogs/non-rentable-space/non-rentable-space.functions';
import {
  NonRentableData,
  ReqDeleteNonRentableSpace,
} from '../../../../dialogs/non-rentable-space/non-rentable-space.model';
import { DataObject } from '../../../../../models/data-object.models';
import { FloorContainerRepository } from '../../../floor-container-repository.service';

@Injectable()
export class DetailsOverlayService {
  constructor(
    private stackingPlanService: StackingPlanService,
    private notificationService: NotificationService,
    private actionsToolbarService: ActionsToolbarService,
    private floorsRepository: FloorContainerRepository
  ) {}

  convertTenancyToNRS(floorNumber: string, data: AbstractSpaceClass): Observable<EfficiencyTransport> {
    const tenantSpace = data as TenantSpaceClass;
    const { totalNumberOfFloors } = this.stackingPlanService.toolbarData;
    const { suiteNumber } = tenantSpace;

    const nonRentableData: NonRentableData = {
      item: null,
      floorNo: floorNumber,
      spaceSize: tenantSpace.getAreaSpace(),
      spaceSizeUOM: tenantSpace.getAreaSpaceUOM(),
      suiteNumber,
      totalNumberOfFloors,
      isReplacingTenant: true,
    };
    const openDialog$ = this.notificationService.openDialog<{
      requestToCreateNRS$: Observable<any>;
      finalSpaceSize?: number;
      finalSpaceSizeUOM?: string;
    }>(NonRentableSpaceComponent, nonRentableData, {
      panelClass: 'table-modals',
    });

    const filteredDialogResult$ = openDialog$.pipe(filter(nonRentableSpace => nonRentableSpace != null));
    return filteredDialogResult$.pipe(
      map(
        (nonRentableSpace: {
          requestToCreateNRS$: Observable<any>;
          finalSpaceSize?: number;
          finalSpaceSizeUOM?: string;
        }) => {
          const { requestToCreateNRS$, finalSpaceSize, finalSpaceSizeUOM } = nonRentableSpace;
          let remainingSpace = 0;
          if (
            nonRentableData.spaceSize != null &&
            finalSpaceSize != null &&
            nonRentableData.spaceSize > finalSpaceSize
          ) {
            remainingSpace = nonRentableData.spaceSize - finalSpaceSize;
          }
          return {
            conversionType: ConversionType.TenancyToNrs,
            floor: floorNumber,
            space: tenantSpace,
            createSpaceRequest$: requestToCreateNRS$,
            remainingSpace,
            remainingSpaceUOM: finalSpaceSizeUOM,
          };
        }
      )
    );
  }

  convertNRStoAvailability(
    floorNumber: string,
    containerRecordFloors: DataObject[],
    data: AbstractSpaceClass
  ): Observable<EfficiencyTransport> {
    const nrsSpace = data as NonRentableSpaceClass;
    const { suiteId } = nrsSpace;

    const { propertyId } = this.stackingPlanService;
    const closeSpaceRequest$ = this.prepareDeleteNRSRequest$(floorNumber, suiteId);
    const efficiencyTransport: EfficiencyTransport = {
      entityName: 'availability',
      space: nrsSpace,
      propertyId,
      floor: floorNumber,
      containerRecordFloors,
      originalSpace: nrsSpace.getAreaSpace(),
      originalSpaceUOM: nrsSpace.getAreaSpaceUOM(),
      closeSpaceRequest$,
      conversionType: ConversionType.NrsToAvailability,
    };
    return of(efficiencyTransport);
  }

  prepareDeleteNRSRequest$(floorNumber: string, suiteId: number): Observable<any> {
    // const { floorInfo } = this.stackingPlanService.floorElevatorInfo.getValue();
    const floorInfo = this.floorsRepository.floorData;
    const { propertyId } = this.stackingPlanService;
    const deleteNRSpace: ReqDeleteNonRentableSpace = deleteNonRentableSpaceInfo(
      floorInfo,
      propertyId,
      suiteId,
      floorNumber
    );
    return this.actionsToolbarService.deleteNonRentableData(deleteNRSpace);
  }
}
